import { logError } from 'client/javascript/util/logger';
import { renderMultipleModules } from 'client/javascript/util/geolocation_based_module_rendering/render_multiple_modules';

export const SELECTORS = {
  CARD_PRODUCT_MODULE: '.card-product',
  CARD_PRODUCT_PROMO_TAG_MODULE: '.card-product__promo'
};

export const setupCardProductPromoTagsModule = (config = {}) => {
  try {
    const { context, selector = SELECTORS.CARD_PRODUCT_PROMO_TAG_MODULE } = config;
    renderMultipleModules({ context, selector });
  } catch (error) {
    logError(`[Card Product] setupCardProductPromoTagsModule failed: ${error.message}`, error);
  }
};

export const setupCardProductModule = () => {
  try {
    renderMultipleModules({ selector: SELECTORS.CARD_PRODUCT_MODULE });
    setupCardProductPromoTagsModule();
  } catch (error) {
    logError(`[Cards Products] setupCardProductModule failed: ${error.message}`, error);
  }
};
